<!-- stateful-secondary-button component -->
<div 
    class="stateful-secondary-button" 
    [attr.aria-label]="this.text + ' button'"
    *ngIf="!this.disabled"
>
    <a 
        class="{{this.selected ? 'selected' : ''}}"
        (click)="this.submit()" 
        (keydown.Space)="this.submit()"
        (keydown.enter)="this.submit()" 
        tabindex="0"
    >
        <span *ngIf="!this.selected">{{this.text}}</span>
        <span *ngIf="this.selected">
            <kendo-loader
              [type]="loader.type"
              [themeColor]="loader.themeColor"
              [size]="loader.size"
            >
            </kendo-loader>
        </span>
    </a>
</div>